import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlStartIconColors = createInteractiveColorVar('controls-start-icon');
const ControlStartIconColorsLightValues = Object.freeze({
    default: '#616161',
    action: '#4D4D4D',
    active: '#000000',
    activeAction: '#616161',
});
const ControlStartIconColorsDarkValues = Object.freeze({
    default: '#B3B3B3',
    action: '#CCCCCC',
    active: '#FFFFFF',
    activeAction: '#B3B3B3',
});

export { ControlStartIconColors, ControlStartIconColorsDarkValues, ControlStartIconColorsLightValues };
